import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerRequestComponent } from './customer-request.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
  ],
  declarations: [CustomerRequestComponent],
})
export class CustomerRequestModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.module.ts